// COLOR TOKENS

/*
  These base colors are to be used when no semantic name exists
  Prefer to use semantic exported name instead of these

  _underscore names do not have a semantic name assigned
*/

export const blue100 = '#EBF2FE'
export const blue150 = '#D0E1FD'
export const blue200 = '#619BF9'
export const blue300 = '#4489F9'
export const blue400 = '#3475F2'
export const blue500 = '#1B2C4F'

export const green30 = '#C8EDE5'
export const green50 = '#B4EFE3'
export const _green100 = '#82DCC9'
export const green150 = '#5FCEB6'
export const green200 = '#14C8B4'
export const green300 = '#23B998'
export const green400 = '#009183'
export const green500 = '#006E65'

export const grey50 = '#FCFCFF'
export const grey100 = '#FCFCFF'
export const grey150 = '#F9F9FD'
export const grey200 = '#F6F7FB'
export const grey300 = '#F0F1F6'
export const grey400 = '#EAEBF1'
export const grey450 = '#DADBE0'
export const grey500 = '#B3B7BE'
export const grey700 = '#697080'
export const grey800 = '#000000'

export const purple100 = '#F6F7FB'
export const purple200 = '#EFEEFE'
export const purple250 = '#D3CFF7'
export const purple300 = '#B1A9F8'
export const purple400 = '#9C92FB'
export const purple500 = '#4F3FDD'
export const purple600 = '#3B2DBD'

export const red100 = '#FAD3D6'
export const red200 = '#F49FA7'
export const red300 = '#D5404A'
export const red400 = '#C11622'
export const red500 = '#A0121B'

export const white100 = '#FFFFFF'

export const yellow50 = '#FFF4CF'
export const _yellow100 = '#FFE1AF'
export const yellow200 = '#F4C72A'
export const yellow800 = '#856700'

export const neutral600 = '#6F6C90'

export const marketingGreen100 = '#E4FFF9'
export const marketingGreen400 = '#21BA99'

// UNKNOWN COLORS
export const progressBarBg = '#d9d9d9'

/*
  BASE COLORS
*/

/** FIGMA: `base/color-action` */
export const base_colorAction = blue300
/** FIGMA: `base/color-action-hover` */
export const base_colorActionHover = blue400
/** FIGMA: `base/color-alert` */
export const base_colorAlert = red300
/** FIGMA: `base/color-alert-hover` */
export const base_colorAlertHover = red400
/** FIGMA: `base/content-hover` */
export const base_contentHover = grey150
/** FIGMA: `base/content-selected` */
export const base_contentSelected = blue100
/** FIGMA: `base/color-surface` */
export const base_colorSurface = purple100
/** FIGMA: `base/color-surface-secondary` */
export const base_colorSurfaceSecondary = grey50
/** FIGMA: `base/color-raised-surface` */
export const base_colorRaisedSurface = white100
/** FIGMA: `base/color-content-border` */
export const base_colorContentBorder = grey450
/** FIGMA: `base/color-content-border-secondary` */
export const base_colorContentBorderSecondary = grey200
/** FIGMA: `base/color-gradient-start` */
export const base_colorGradientStart = purple300
/** FIGMA: `base/color-gradient-end` */
export const base_colorGradientEnd = purple200
/** FIGMA: `base/color-highlight */
export const base_colorHighlight = purple500

/*
  CTA Colors
*/

/** FIGMA: `cta/link-text-primary` */
export const cta_linkTextPrimary = base_colorAction
/** FIGMA: `cta/link-text-primary-hover` */
export const cta_linkTextPrimaryHover = base_colorActionHover
/** FIGMA: not in Figma variables: `red_300` */
export const cta_linkTextAlert = red300
/** FIGMA: not in Figma variables: `red_400` */
export const cta_linkTextAlertHover = red400
/** FIGMA: `cta/button-primary-background` */
export const cta_buttonPrimaryBackground = base_colorAction
/** FIGMA: `cta/button-primary-background-hover` */
export const cta_buttonPrimaryBackgroundHover = base_colorActionHover
/** FIGMA: `cta/button-primary-border` */
export const cta_buttonPrimaryBorder = blue400
/** FIGMA: `cta/button-primary-text` */
export const cta_buttonPrimaryText = white100
/** FIGMA: `cta/button-secondary-background` */
export const cta_buttonSecondaryBackground = grey100
/** FIGMA: `cta/button-secondary-background-hover` */
export const cta_buttonSecondaryBackgroundHover = grey150
/** FIGMA: `cta/button-secondary-border` */
export const cta_buttonSecondaryBorder = grey450
/** FIGMA: `cta/button-secondary-text` */
export const cta_buttonSecondaryText = base_colorAction
/** FIGMA: `cta/alert-button-background` */
export const cta_alertButtonBackground = red300
/** FIGMA: `cta/alert-button-background-hover` */
export const cta_alertButtonBackgroundHover = red400
/** FIGMA: `cta/alert-button-border` */
export const cta_alertButtonBorder = red400
/** FIGMA: not in Figma variables: `grey_400` */
export const cta_noshellButtonBackgroundHover = grey400
/** FIGMA: not in Figma */
export const cta_noshellButtonAnimatedCircle = grey200
/** FIGMA: not in Figma */
export const cta_spotlightButtonBackground = purple500
/** FIGMA: not in Figma */
export const cta_spotlightBackgroundHover = purple600
/** FIGMA: not in Figma */
export const cta_spotlightButtonBorder = purple600

/*
  Gradient Colors
*/
/** FIGMA: `gradient/brand-gradient-start` */
export const gradient_brandGradientStart = green150
/** FIGMA: `gradient/brand-gradient-end` */
export const gradient_brandGradientEnd = blue200
/** FIGMA: `gradient/bar-chart-gradient-start` */
export const gradient_barChartGradientStart = purple300
/** FIGMA: `gradient/bar-chart-gradient-end` */
export const gradient_barChartGradientEnd = purple200
/** FIGMA: `gradient/selected-gradient-start` */
export const gradient_selectedGradientStart = purple500
/** FIGMA: `gradient/selected-gradient-end` */
export const gradient_selectedGradientEnd = purple400
/** FIGMA: `gradient/marketing-gradient-start` */
export const gradient_marketingGradientStart = marketingGreen100
/** FIGMA: `gradient/marketing-gradient-end` */
export const gradient_marketingGradientEnd = white100

/*
  Charts/Bar-Chart Colors
*/
/** FIGMA: `charts/bar-chart/bill-pay-default` */
export const charts_barChartBillPayDefault = green300
/** FIGMA: `charts/bar-chart/bill-pay-disabled` */
export const charts_barChartBillPayDisabled = green30
/** FIGMA: `charts/bar-chart/virtualCards-default` */
export const charts_barChartVirtualCardsDefault = purple400
/** FIGMA: `charts/bar-chart/virtualCards-disabled` */
export const charts_barChartVirtualCardsDisabled = purple200
/** FIGMA: `charts/bar-chart/physicalCards-default` */
export const charts_barChartPhysicalCardsDefault = blue300
/** FIGMA: `charts/bar-chart/physicalCards-disabled` */
export const charts_barChartPhysicalCardsDisabled = blue150

/*
  Logo Colors
*/
/** FIGMA: `logo/color-logo-primary` */
export const logo_colorLogoPrimary = green400
/** FIGMA: `logo/color-logo-secondary` */
export const logo_colorLogoSecondary = green200

/*
  Graphics Colors
*/
/** FIGMA: `graphics/illustration-gradient-primary-start` */
export const graphics_illustrationGradientPrimaryStart = logo_colorLogoPrimary
/** FIGMA: `graphics/illustration-fill-secondary` */
export const graphics_illustrationFillSecondary = marketingGreen100
/** FIGMA: `graphics/illustration-fill-primary` */
export const graphics_illustrationFillPrimary = marketingGreen400

/*
  Notification Colors
*/
/** FIGMA: `notifications/color-alert` */
export const notification_colorAlert = red300

/*
  Nav Colors
*/
/** FIGMA: `nav/nav-item-color-selected` */
export const nav_navItemColorSelected = base_contentSelected
/** FIGMA: `nav/nav-accordion-color-selected` */
export const nav_navAccordionColorSelected = grey200

/*
  Table Colors
*/
/** FIGMA: `table/table-border-color` */
export const table_tableBorderColor = base_colorContentBorder
/** FIGMA: `table/table-row-selected` */
export const table_tableRowSelected = base_contentSelected
/** FIGMA: `table/table-row-hover` */
export const table_tableRowHover = base_contentHover

/*
  Tag Colors
*/
/** FIGMA: `tag/color-tag-highlight-background` */
export const tag_colorTagHighlightBackground = green50
/** FIGMA: `tag/color-tag-highlight-background-hover` */
export const tag_colorTagHighlightBackgroundHover = _green100
/** FIGMA: `tag/color-tag-highlight-text` */
export const tag_colorTagHighlightText = green500
/** FIGMA: `tag/color-tag-highlight-text-hover` */
export const tag_colorTagHighlightTextHover = green400
/** FIGMA: `tag/color-tag-default-background` */
export const tag_colorTagDefaultBackground = grey400
/** FIGMA: `tag/color-tag-default-background-hover` */
export const tag_colorTagDefaultBackgroundHover = grey450
/** FIGMA: `tag/color-tag-default-text` */
export const tag_colorTagDefaultText = grey800
/** FIGMA: `tag/color-tag-default-text-hover` */
export const tag_colorTagDefaultTextHover = grey800
/** FIGMA: `tag/color-tag-severe-text` */
export const tag_colorTagSevereText = red400
/** FIGMA: `tag/color-tag-severe-text-hover` */
export const tag_colorTagSevereTextHover = red500
/** FIGMA: `tag/color-tag-severe-background` */
export const tag_colorTagSevereBackground = red100
/** FIGMA: `tag/color-tag-severe-background-hover` */
export const tag_colorTagSevereBackgroundHover = red200
/** FIGMA: `tag/color-tag-pending-text` */
export const tag_colorTagPendingText = yellow800
/** FIGMA: `tag/color-tag-pending-text-hover` */
export const tag_colorTagPendingTextHover = yellow800
/** FIGMA: `tag/color-tag-pending-background` */
export const tag_colorTagPendingBackground = yellow50
/** FIGMA: `tag/color-tag-pending-background-hover` */
export const tag_colorTagPendingBackgroundHover = _yellow100
/** FIGMA: `tag/color-tag-new-text` */
export const tag_colorTagNewText = purple500
/** FIGMA: `tag/color-tag-new-text-hover` */
export const tag_colorTagNewTextHover = purple600
/** FIGMA: `tag/color-tag-new-background` */
export const tag_colorTagNewBackground = purple200
/** FIGMA: `tag/color-tag-new-background-hover` */
export const tag_colorTagNewBackgroundHover = purple250
/** FIGMA: `tag/color-tag-blue-text` */
export const tag_colorTagBlueText = blue400
/** FIGMA: `tag/color-tag-blue-text-hover` */
export const tag_colorTagBlueTextHover = blue500
/** FIGMA: `tag/color-tag-blue-background` */
export const tag_colorTagBlueBackground = blue100
/** FIGMA: `tag/color-tag-blue-background-hover` */
export const tag_colorTagBlueBackgroundHover = blue150
/*
  Text Colors
*/
/** FIGMA: `text/color-text-primary` */
export const text_colorTextPrimary = blue500
/** FIGMA: `text/color-text-secondary` */
export const text_colorTextSecondary = grey700
/** FIGMA: `text/color-text-tertiary` */
export const text_colorTextTertiary = grey400
/** FIGMA: `text/color-text-branded` */
export const text_colorTextBranded = green300
/** FIGMA: `text/color-text-accent` */
export const text_colorTextAccent = green500

/*
  Overlay Colors
*/
export const overlay_backgroundBase = blue500
// Using 8-digit hex codes, the last two are opacity
export const overlay_backgroundNotFocused = `${overlay_backgroundBase}C7` // 0xC0 = 75%
export const overlay_backgroundFocused = `${overlay_backgroundBase}77` // 0x77 = 45%
